
export class Level {
    currentAmount: number;
    highestWinningAmount: number;
    highestWinningDate: Date;
    latestWinningAmount: number;
    latestWinningDate: Date;
    latestWinningPlayer: string;
    numberOfWins: number;
}

export default class Banner {
    currency: string;
    levels: Level[];
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/games/JackpotBanner.ts